import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const consumableItemConfig = {
  /* ------------------------------- GET ---------------------------------- */

  getAllConsumableItems: {
    key: "getAllConsumableItems",
    url: "/api/v1/consumable-items",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getAvailableConsumableItems: {
    key: "getAvailableConsumableItems",
    url: (data) => `/api/v1/consumable-items/available-for-room-type/${data.roomTypeId}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getConsumableItemById: {
    key: "getConsumableItemById",
    url: (data) => `/api/v1/consumable-items/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  /* ------------------------------- POST ---------------------------------- */

  createConsumableItem: {
    key: "createConsumableItem",
    url: "/api/v1/consumable-items",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllConsumableItems", "getAvailableConsumableItems"],
      onSuccessMessage: "Consumable item created successfully",
      onErrorMessage: "Failed to create consumable item",
    },
  },

  /* ------------------------------- PUT ---------------------------------- */

  updateConsumableItem: {
    key: "updateConsumableItem",
    url: (data) => `/api/v1/consumable-items/${data.id}`,
    method: "PUT",
    options: {
      retry: 2,
      invalidateKeys: ["getAllConsumableItems", "getAllParLevels", "getParLevelsByRoomType", "getRoomInventory"],
      onSuccessMessage: "Consumable item updated successfully",
      onErrorMessage: "Failed to update consumable item",
    },
  },

  /* ------------------------------- DELETE ---------------------------------- */

  deleteConsumableItem: {
    key: "deleteConsumableItem",
    url: (data) => `/api/v1/consumable-items/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getAllConsumableItems", "getAllParLevels", "getParLevelsByRoomType", "getRoomInventory"],
      onSuccessMessage: "Consumable item deleted successfully",
      onErrorMessage: "Failed to delete consumable item",
    },
  },

  /* ------------------------------- RESTORE ---------------------------------- */

  restoreConsumableItem: {
    key: "restoreConsumableItem",
    url: (data) => `/api/v1/consumable-items/${data.id}/restore`,
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllConsumableItems", "getAllParLevels", "getParLevelsByRoomType", "getRoomInventory"],
      onSuccessMessage: "Consumable item restored successfully",
      onErrorMessage: "Failed to restore consumable item",
    },
  },
};
